/**
 * @deprecated - use NETWORK_SLUGS from `src/consts.ts` instead
 */
export enum Networks {
    algorand = "algorand",
    aptos = "aptos",
    arbitrum = "arbitrum",
    avalanche = "avalanche-c-chain",
    base = "base",
    bitcoin = "bitcoin",
    blast = "blast",
    bnbChain = "bnb-chain",
    canto = "canto",
    canton = "canton",
    celo = "celo",
    eos = "eos",
    ethereum = "ethereum",
    ethereumClassic = "ethereum classic",
    flow = "flow",
    gnosis = "gnosis",
    hedera = "hedera",
    hyperEVM = "hyperevm",
    injective = "injective",
    ink = "ink",
    kava = "kava",
    liquid = "liquid-network",
    mantle = "mantle",
    mantra = "mantra",
    monad = "monad",
    near = "near",
    noble = "noble",
    optimism = "optimism",
    pharos = "pharos",
    plasma = "plasma",
    plume = "plume",
    polkadot = "polkadot",
    polygon = "polygon",
    PolygonzkEVM = "polygon zkevm",
    provenance = "provenance",
    robinhoodChain = "robinhood",
    rootstock = "rootstock",
    sei = "sei",
    solana = "solana",
    stellar = "stellar",
    sui = "sui",
    tempo = "tempo",
    tezos = "tezos",
    tron = "tron",
    xdc = "xdc",
    xrpLedger = "xrp-ledger",
    zksyncEra = "zksync-era",
}
